import { render, staticRenderFns } from "./ProdesResiduosAmazonia.vue?vue&type=template&id=6d94d04a&lang=pug"
import script from "./ProdesResiduosAmazonia.vue?vue&type=script&lang=js"
export * from "./ProdesResiduosAmazonia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports